<template>
  <div class="section">
    <h1 class="title is-size-1" :aria-label="$t('faq.title')">
      {{ $t("faq.title") }}
    </h1>
    <hr />
    <div class="content is-medium">
      <h3 :aria-label="$t('How does the search work?')">
        {{ $t("How does the search work?") }}
      </h3>
      <p :aria-label="$t('Detailed search instructions can be found')">
        {{ $t("Detailed search instructions can be found") }}
        <router-link :to="{ name: 'usage' }">{{ $t("here") }}.</router-link>
      </p>
      <hr />
      <template v-for="(section, index) in $t('faq.sections')">
        <h3 :aria-label="section.title">{{ section.title }}</h3>
        <template v-for="(content, index) in section.content">
          <p :key="index" :aria-label="content" v-html="content"></p>
        </template>
        <hr />
      </template>
    </div>
  </div>
</template>

<style scoped>
hr {
  margin: 4.75rem 0 !important;
}
</style>

<script>
export default {
  layout: "content",
};
</script>
